<template>
    <div class="zhuanyeku" id="zhuanyeku" :class="activeMenu == 0 ? 'zhuanyeku_benke': 'zhuanyeku_zhuanke'">       
        <div class="undingwei"  >
            <div class="dingwei_inner">
                <div class="inner_box">
                    <div class="searchBox">
                        <input type="text" v-model.trim="searchValue" placeholder="搜索你感兴趣的专业" @keydown.enter="query">
                        <span @click="query">
                            <img src="/imgs/explore/common/icon_search.png" alt="">
                        </span>
                    </div>
                    <div class="top_navs">
                        <!-- 本科、专科 -->
                        <div class="education">
                            <div class="inner">
                                <ul>
                                    <li v-for="(item, index) in dictData" :key="index" @click="tabChange(index)"  :class="index == activeMenu ? 'active': ''">{{item.majorTypeName}}</li>
                                </ul>
                            </div>
                        </div>
                        <!-- 学科门类 -->
                        <div class="discipline ">
                            <div class="inner">
                                <div class="right" id="right">
                                    <span v-for="(item, index) in dictData[activeMenu].majorCategorys"  :class="index == itemActive ? 'active' : ''" @click="changeItem(index)">{{item.majorCategoryName}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main_content" style="paddingTop:0">
            <div class="inner">
                <!-- 专业 -->
                <div class="major" v-show="!isShowSearchData">
                    <div class="neirongBox" >
                        <p class="title" >{{dictData[activeMenu].majorCategorys[itemActive].majorCategoryName}}</p>
                        <div class="major_lei_box" >
                            <span class="major_lei" @click="childChange(index,item.majorMLID)"  v-for="(item, index) in dictData[activeMenu].majorCategorys[itemActive].majorMls" :class="index == childActive ? 'active' : ''" :key="index" >{{item.majorMLName}}</span>              
                        </div>
                        <div class="right_major">
                            <p v-for="(item, index)  in childItem" :key="index" >
                                <span>{{item.majorName}}</span>
                                <span>专业代码：{{item.majorCode}}</span>
                                <span @click="detail(item.id)">查看</span>
                            </p>
                        </div>
                    </div>
                </div>
                 <!-- 搜索展示 -->
                <div class="major" v-show="isShowSearchData">
                    <div class="tishi" v-show="searchData.length == 0">
                        没有满足条件的结果,换一个试试？
                    </div>
                    <div class="neirongBox" v-show="searchData.length > 0">
                        <div class="major_lei_box search-major_lei_box" v-for="(item, index) in searchData">
                            <div class="major_lei">{{item.majorMLName}}</div>
                            <div class="right_major">
                                <p v-for="(major, index) in item.majorMls">
                                    <span >{{major.majorName}}</span>
                                    <span>专业代码：{{major.majorCode}}</span>
                                    <span @click="detail(major.id)" >查看</span>                                  
                               </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>    
        </div>
    </div>
</template>
<style type="text/css" lang='less' scoped>
    *{
        letter-spacing: 1px;
    }
    .right_major {
        padding: 0px;
        // display:flex;
        // flex-wrap: wrap;
    }
    .right_major p{
        height: 36px;
        line-height: 36px;
        cursor: pointer;
        // display: inline-block;
        white-space: nowrap;
        // float: left;
        font-size: 13px;
        padding: 0 20px;
        border-bottom:1px solid #eaebec;
        // padding-left:50px;
        display:flex;
        justify-content:space-between;
        span{
            flex:1
        }
        span:nth-child(2){
            text-align:right;
        }
        span:last-child{
            text-align:right;
            flex:.5;
        }
        span:last-child:hover{
            color: #2c8ffc;
        }

    }
    .zhuanyeku {
        // margin-left: 20px;
        background-color: #f5f5f5;
        padding-bottom: 30px;
        .dingwei {
            position: fixed;
            left: 0px;
            top: 0px;
            width: 100%;
            z-index: 2;
            .dingwei_inner {
                box-sizing: border-box;
                width: 1200px;
                margin: 0 auto;
                padding-left: 230px;
                .inner_box {
                    box-sizing: border-box;
                    width: 970px;
                    padding: 0px 20px;
                    padding-top: 20px;
                    background-color: #fff;
                    box-shadow: 0 0 6px #dedede;
                }
            }
        }
        .undingwei {            
            background-color: #fff;
            padding: 0px 10px;
            padding-top: 20px;
            .dingwei_inner {
                padding: 0px;
            }
        }
        .searchBox{
            height: 40px;
            margin-bottom: 10px;          
            border-radius: 5px;
            position: relative;
           
            input {
                height: 44px;
                border: 1px solid #2c8ffc;
                width: 100%;
                padding-left: 20px;
                font-size: 14px;
                line-height: 42px;
                border-radius: 27px;
                box-sizing: border-box;
            }
            span {
                width: 40px;
                height: 44px;
                font-size: 14px;
                line-height: 44px;
                text-align: center;
                color: #fff;
                cursor: pointer;
                position: absolute;
                right: 10px;
                top: 0;
                overflow: hidden;
            }
        }
        .inner {
            box-sizing: border-box;
            
            margin: 0 auto;
        }
        .top_navs {
            background-color: #fff;
            .education {
                width: 100%;
                border-bottom: 1px solid #eaebec;
                ul {
                    height: 42px;
                    li {
                        float: left;
                        width: 96px;
                        margin-right: 24px;
                        height: 42px;
                        color: #333;
                        font-size: 15px;
                        font-weight: 600;
                        line-height: 42px;
                        box-sizing: border-box;
                        cursor: pointer;
                        text-align: center;
                    }
                    .active {
                        color: #2c8ffc;
                        border-bottom: 2px solid #2c8ffc;
                    }
                }
            }
            .discipline {
                .right {
                    font-size: 14px;
                    color: #333333;
                    padding: 15px 8px;
                    padding-bottom: 0px;
                    overflow: hidden;
                    span {
                        float: left;
                        font-size: 15px;
                        height: 30px;
                        line-height: 30px;
                        padding: 0px 15px;
                        margin-bottom: 10px;
                        cursor: pointer;
                        margin-right: 0px;
                        &:hover {
                            background-color: #2c8ffc;
                            border-radius: 5px;
                            color: #fff;
                        }
                    }
                    .active {
                        background-color: #2c8ffc;
                        border-radius: 5px;
                        color: #fff;
                    }
                }
            }
        } 
        .loading {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(255,255,255,.6);
        }
    }
    .main_content {
        min-height: 1000px;
        height: auto;
        background-color: #fff;
        transition: all 0s;
        .inner {
            // width: 930px;
            margin: 0 auto;
            background-color: #fff;
        }
        .major {
            .tishi {
                text-align: center;
                font-size: 18px;
                line-height: 200px;
                color:#666;
                position: relative;
                height: 200px;
            }
            .neirongBox {
                padding-top: 20px;
                .title {
                    &:before {
                        content: '';
                        width: 4px;
                        height: 17px;
                        position: absolute;
                        left: 0;
                        top: 50%;
                        margin-top: -8px;
                        background-color: #2c8ffc;
                    }
                    position: relative;
                    height: 40px;
                    font-size: 16px;
                    color: #333333;
                    line-height: 40px;
                    font-weight: 600;
                    padding-left: 15px;
                    margin-bottom: 20px;
                    background-color: #f5f5f5;
                }
                .major_lei_box {
                    padding: 0 15px;
                    overflow: hidden;
                    display:flex;
                    border-bottom: 1px solid #eaebec;
                    flex-wrap:wrap;
                    padding-bottom:20px;
                    
                    .major_lei {
                        height: 30px;
                        line-height: 30px;
                        
                        color: #333;
                        font-weight: 600;
                        padding:0 10px;
                        cursor:pointer;
                    }
                    .major_lei.active{
                        background-color: #2c8ffc;
                        border-radius: 5px;
                        color: #fff;
                    }

                    .right_major {
                        padding: 8px 0px;
                        // display: flex;
                        // flex-wrap: wrap;
                        p {
                            height: 36px;
                            line-height: 36px;
                            cursor: pointer;
                            // display: inline-block;
                            white-space:nowrap;
                            // float: left;
                            font-size: 13px;
                            padding:0 10px;
                            border-bottom:1px solid #eaebec;
                            display:flex;
                            justify-content:space-between
                            span {
                                display: inline-block;
                                padding: 0px 2px;
                                height: 100%;
                                color: #333;
                                cursor: pointer;
                            }                      
                        }
                    }
                }
            }
        }
    }
    .zhuanyeku_benke {
        // padding-top: 190px;
    }
    .zhuanyeku_zhuanke {
        // padding-top: 270px;
    }
    .search-major_lei_box{
       display: grid !important;
       padding-top:8px !important;
       
       padding-bottom:0 !important;
      >.right_major > p{
        border-bottom:none !important;
      }
    }
</style>
<script>
// import Loading from '../../../.././components/Loading.vue'   
export default {
    // components: { Loading },
    props: [ 'message' ],
    data() {
        return {
            dictData:[],
            activeMenu:0, //本科专科列表 
            itemActive:0,//一级专业列表
            childActive:0, //二级专业列表
            childItem:[],//三级内容 待进入详情
            searchValue:'', //搜索框
            isShowSearchData:false,
            searchData:[],
        }
    },
    methods: {
        // 重新写调接口大类
        getMajor(){
            var _this = this;
            var token = window.sessionStorage.getItem('ymtxToken')||window.localStorage.getItem('localtoken');
            this.$ajax
                // get请求
                .post(this.G_uri + '/major/dict ', {
                },{
                    headers:{
                        token: token
                    }
                })
                // 监听数据返回
                .then(function(res) {                  
                    if(res.status == 200) {   
                       let data = res.data.data;
                       _this.dictData = data;
                       _this.getChild(_this.dictData[0].majorCategorys[0].majorMls[0].majorMLID);
                       
                    }else if(res.data.code == 1016) {
                        _this.$router.push('/login')
                    }
                    
                })
                .catch(function(error) {
                    console.log(error)
                })
        } ,
        tabChange(index){   
            var  _this = this;                  
            _this.activeMenu = index;
            _this.itemActive = 0
            _this.childActive = 0;
            // 传入第一个id
            _this.getChild(_this.dictData[_this.activeMenu].majorCategorys[0].majorMls[0].majorMLID);

        },
        changeItem(index){
            var _this = this;   
            _this.itemActive = index;
            _this.childActive = 0;
            _this.getChild(_this.dictData[_this.activeMenu].majorCategorys[_this.itemActive].majorMls[0].majorMLID);
            _this.isShowSearchData = false;
            _this.searchValue = '';
            _this.searchData = [];

        },
        childChange(index,id){
            var _this = this;
            _this.childActive = index;
            this.getChild(id)
        },
        // 获取详情第三级
        getChild(id){
            var _this = this;
            var token = window.sessionStorage.getItem('ymtxToken') || window.localStorage.getItem('localtoken');
            this.$ajax
                // get请求
                .post(this.G_uri + '/major/list', {
                    majorMLID:id
                },{
                    headers:{
                        token: token
                    }
                })
                // 监听数据返回
                .then(function(res) {                  
                    if(res.status == 200) {   
                            // console.log(res,'详情')  
                            let data = res.data.data;
                            _this.childItem = data;        
                       
                    }else if(res.data.code == 1016) {
                        _this.$router.push('/login')
                    }
                    
                })
                .catch(function(error) {
                    console.log(error)
                })
        },
        // 查询搜索
        query() {
            var _this = this;
            var name = _this.searchValue;
            if(!name) {
                _this.isShowSearchData = false;
                return false
            }
            var token = window.sessionStorage.getItem('ymtxToken') || window.localStorage.getItem('localtoken');
            this.$ajax
                // get请求
                .post(this.G_uri + '/major/majorSearch', {
                    majorName: name
                },{
                    headers:{
                        token: token
                    }
                })
                // 监听数据返回
                .then(function(res) {
                        console.log(res,'ooooo');
                        _this.isShowSearchData = true;
                        _this.searchData = res.data.data;
                })
                .catch(function(error) {
                    console.log(error)
                })
        },
        // 跳详情
        detail(id){
            var id = id;
            let {href}=this.$router.resolve({
                path: '/zhuanyexiangqing_mobile',
                name: '专业详情',
                query: {
                    id: id,
                    from: 'zhuanyeku'
                }
            })           
            this.$router.push({path:'/zhuanyexiangqing_mobile',query:{id: id,from: 'zhuanyeku'}})
        }
    },
    mounted() {
        this.getMajor()
    },
}
</script>